import api from '../../../../helpers/api';

export const getSupplierPublicInquiry = body =>
  api.post('public-supplier-inquiry/get-single-public-supplier-inquiry', {
    ...body
  });

export const getSupplierPublicInquiries = body =>
  api.post(
    body.url
      ? body.url
      : `public-supplier-inquiry/search-public-supplier-inquiries/`,
    { ...body }
  );

export const deleteSupplierPublicInquiry = id =>
  api.delete(`public-supplier-inquiry/${id}`);

export const addSupplierPublicInquiry = body =>
  api.post(`public-supplier-inquiry-staging/create`, { ...body });
export const addSupplierPublicInquiryTrusted = body =>
  api.post(`/public-supplier-inquiry/`, { ...body });

export const addSupplierPendingPublicInqiury = body =>
  api.post(`public-supplier-staging-proposals/create`, { ...body });

export const editSupplierPublicInquiry = (id, body) =>
  api.post(`public-supplier-inquiry-staging/update${id}`, { ...body });

export const editSupplierPublicInquiryTrusted = (id, body) =>
  api.put(`public-supplier-inquiry/${id}`, { ...body });
